import { useQuery } from '@tanstack/react-query'

import API from './api'

export const useApp = () =>
  useQuery({
    queryKey: ['app'],
    queryFn: () => {
      return new Promise((resolve, reject) => {
        return API.getApp()
          .then(data => {
            console.log('[API] getApp', data)
            resolve(data)
          })
          .catch(err => {
            console.error('[API] getApp', err)
            reject(err)
          })
      })
    },
    retry: true,
    retryDelay: 3000
  })

export const useExternalDevices = () => {
  return useQuery({
    queryKey: ['externalDevices'],
    queryFn: () => {
      return new Promise((resolve, reject) => {
        return API.getExternalDevices()
          .then(res => {
            console.log('[API] getExternalDevices', res)
            console.log('[API] getExternalDevices', JSON.stringify(res.data))
            resolve(res.data)
          })
          .catch(err => {
            console.error('[API] getExternalDevices', err)
            reject(err)
          })
      })
    },
    retry: false
  })
}
